import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="relative overflow-hidden bg-[linear-gradient(135deg,_#0f172a_0%,_#022c22_45%,_#064e3b_100%)] pt-16 text-white">
            <div className="absolute -left-20 -top-16 h-60 w-60 rounded-full bg-emerald-400/20 blur-3xl"></div>
            <div className="absolute -bottom-16 right-0 h-56 w-56 rounded-full bg-cyan-400/20 blur-3xl"></div>

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mb-10 grid grid-cols-1 gap-8 md:grid-cols-4">
                    <div>
                        <h3 className="text-2xl font-black text-emerald-300">YAP</h3>
                        <p className="mt-4 text-sm leading-relaxed text-emerald-50/90">
                            Youth Association of Pakistan builds opportunities for young people through education, development programs, and community action.
                        </p>
                        <div className="mt-4 flex gap-3 text-emerald-200">
                            <a href="https://www.facebook.com/YAofPakistan" target="_blank" rel="noreferrer" className="rounded-full border border-white/20 p-2 hover:bg-white/10"><FaFacebook /></a>
                            <a href="https://x.com/YAofPakistan" target="_blank" rel="noreferrer" className="rounded-full border border-white/20 p-2 hover:bg-white/10"><FaTwitter /></a>
                            <a href="https://www.instagram.com/yaopakistan/" target="_blank" rel="noreferrer" className="rounded-full border border-white/20 p-2 hover:bg-white/10"><FaInstagram /></a>
                            <a href="https://www.linkedin.com/company/youth-association-of-pakistan/" target="_blank" rel="noreferrer" className="rounded-full border border-white/20 p-2 hover:bg-white/10"><FaLinkedin /></a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold">Primary</h4>
                        <ul className="mt-4 space-y-2 text-sm text-emerald-50/90">
                            <li><Link to="/" className="hover:text-emerald-300">Home</Link></li>
                            <li><Link to="/about" className="hover:text-emerald-300">About</Link></li>
                            <li><Link to="/projects" className="hover:text-emerald-300">Projects</Link></li>
                            <li><Link to="/donate" className="hover:text-emerald-300">Donate</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold">Discover</h4>
                        <ul className="mt-4 space-y-2 text-sm text-emerald-50/90">
                            <li><Link to="/advisory-board" className="hover:text-emerald-300">Advisory Board</Link></li>
                            <li><Link to="/impact-stories" className="hover:text-emerald-300">Impact Stories</Link></li>
                            <li><Link to="/volunteer" className="hover:text-emerald-300">Volunteer</Link></li>
                            <li><Link to="/faq" className="hover:text-emerald-300">FAQ</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold">Contact</h4>
                        <div className="mt-4 space-y-3 text-sm text-emerald-50/90">
                            <p className="flex items-center gap-2"><FaMapMarkerAlt className="text-emerald-300" /> Islamabad, Pakistan</p>
                            <p className="flex items-center gap-2"><FaPhone className="text-emerald-300" /> +92 (051) 2741333</p>
                            <p className="flex items-center gap-2"><FaEnvelope className="text-emerald-300" /> info@yapngo.pk</p>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/10 py-6 text-sm text-emerald-50/80">
                    <div className="flex flex-col items-center justify-between gap-3 md:flex-row">
                        <p>� 2026 | Youth Association of Pakistan | All rights reserved | <Link to={`https://wa.link/4lvz2u`} className='text-red'>Managed by Bretsol</Link></p>
                        <div className="flex gap-5">
                            <a href="#" className="hover:text-emerald-300">Privacy Policy</a>
                            <a href="#" className="hover:text-emerald-300">Terms of Service</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
